"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _actions = require("../actions");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var reducer = function reducer(state, action) {
  switch (action.type) {
    case _actions.UPDATE_CUSTOM_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        locale: action.data.cart.languageCode,
        environment: action.data.environment || state.environment,
        customData: action.data
      });
    case _actions.UPDATE_PAYMENT_RESPONSE:
      {
        var _action$payload = _slicedToArray(action.payload, 2),
          res = _action$payload[0],
          status = _action$payload[1];
        if (status >= 300) {
          return _objectSpread(_objectSpread({}, state), {}, {
            error: res
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          paymentRes: res
        });
      }
    case _actions.UPDATE_PAYMENT_DETAILS_RESPONSE:
      {
        var _action$payload2 = _slicedToArray(action.payload, 2),
          _res = _action$payload2[0],
          _status = _action$payload2[1];
        if (_status >= 300) {
          return _objectSpread(_objectSpread({}, state), {}, {
            error: _res
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          paymentDetailsRes: _res
        });
      }
    case _actions.UPDATE_GET_PAYMENT_METHODS_RESPONSE:
      {
        var _action$payload3 = action.payload,
          activePaymentMethods = _action$payload3.activePaymentMethods,
          paymentMethodsRes = _action$payload3.paymentMethodsRes;
        return _objectSpread(_objectSpread({}, state), {}, {
          activePaymentMethods: activePaymentMethods,
          paymentMethodsRes: paymentMethodsRes
        });
      }
    case _actions.UPDATE_ACTIVE_PAYMENT_METHODS:
      {
        var _activePaymentMethods = action.payload;
        return _objectSpread(_objectSpread({}, state), {}, {
          activePaymentMethods: _activePaymentMethods
        });
      }
    case _actions.UPDATE_PAYMENT_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.error
      });
    case _actions.UPDATE_CART_AMOUNT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          cartAmount: action.payload
        });
      }
    case _actions.UPDATE_SELECTED_PAYMENT_METHOD:
      {
        var selectedPaymentMethod = action.payload;
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedPaymentMethod: selectedPaymentMethod
        });
      }
    case _actions.UPDATE_BEFORE_SUBMIT_RESPONSE:
      {
        var beforeSubmitResponse = action.payload;
        return _objectSpread(_objectSpread({}, state), {}, {
          beforeSubmitResponse: beforeSubmitResponse
        });
      }
    case _actions.UPDATE_POST_VALIDATE_RESPONSE:
      {
        var postValidateResponse = action.payload;
        return _objectSpread(_objectSpread({}, state), {}, {
          postValidateResponse: postValidateResponse
        });
      }
    case _actions.REGISTER_AUTH_CALL_HANDLER:
      {
        var _action$payload4 = action.payload,
          paymentMethod = _action$payload4.paymentMethod,
          authCallHandler = _action$payload4.authCallHandler;
        return _objectSpread(_objectSpread({}, state), {}, {
          authCallHandlers: _objectSpread(_objectSpread({}, state.authCallHandlers), {}, _defineProperty({}, paymentMethod, authCallHandler))
        });
      }
    default:
      return state;
  }
};
var _default = reducer;
exports.default = _default;